import { push } from "connected-react-router";
import { appendQueryParams } from "../../utils/url";
import { closePopup, openPopup } from "../popups";

export const showPopup =
	(popup, props = {}, className = {}, style = {}) =>
	(dispatch, getState) => {
		const { addEventListener, removeEventListener } = window;

		return new Promise(async (onSuccess) => {
			await dispatch(openPopup({ popup, props, className, style }));
			const state = getState();
			const popups = state.popups.list.map((popup) => {
				return popup.popup;
			});

			const url = appendQueryParams({
				popups: popups.toString(),
			});

			dispatch(push(url.pathname + url.search));

			const handleHide = (e) => {
				if (e.data.popup === popup) {
					onSuccess(e.data.results);
					removeEventListener(closePopup.type, handleHide);
					const url1 = appendQueryParams({
						popup:
							getState()
								.popups.list.map((popup) => {
									return popup.popup;
								})
								.toString() || null,
					});
					dispatch(push(url1.pathname + url1.search));
				}
			};
			addEventListener(closePopup.type, handleHide);
		});
	};

export const hidePopup = (popup) => (dispatch, getState) => {
	return new Promise(async (onSuccess) => {
		await dispatch(closePopup({ popup }));
		onSuccess(true);
	});
};
